import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { addPhoneNumber } from '../../utils/api/phoneNumberAPI';
import { toast } from 'sonner';
import { getAllIntegrations } from '../../utils/api/integrationAPI';

function AddPhoneNumberModal({ onClose }) {
  const [formData, setFormData] = useState({
    accountId: '',
    password: '',
    did: '',
    domain: '',
    provider: '',
    integrationId: '',
    externalId: '',
  });

  const [integration, setIntegration] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getAllIntegrations().then((data) =>
      setIntegration(data?.integrations || [])
    );
  }, []); 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await addPhoneNumber(formData);
      toast.success(response?.message || 'Phone number added successfully');
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.message || e?.message || 'Something went wrong');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-view-container d-flex justify-content-center align-items-center p-3">
      <motion.div
        className="bg-white rounded-4 shadow-lg d-flex flex-column w-100"
        style={{
          maxWidth: '1200px',
          maxHeight: '90vh',
          overflow: 'hidden',
          margin: '10px',
        }}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        {/* Modal Header */}
        <div className="d-flex justify-content-between align-items-center border-bottom px-4 py-3" style={{
          marginInline: '20px',
        }}>
          <h6>Add Phone Number</h6>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onClose}
          ></button>
        </div>

        {/* Modal Form Body */}
        <form
          onSubmit={handleSubmit}
          className="px-4 py-3 overflow-auto"
          style={{ flexGrow: 1, overflowY: 'auto', margin: '20px' }}
        >
          <div className="row g-3">
            {[
              ['Account ID', 'accountId', 'text', true],
              ['Password', 'password', 'password', true],
              ['DID', 'did', 'text', true],
              ['Domain', 'domain', 'text', true],
              ['Provider', 'provider', 'text', true],
              ['Organization', 'integrationId', 'dropdown', true],
              ['External ID', 'externalId', 'text', true],
            ].map(([label, name, type, required]) => (
              <div key={name} className="col-12 col-md-6">
                <label className="form-label">{label}</label>
                {name === 'integrationId' ? (
                  <select
                    className="form-control"
                    name={name}
                    value={formData[name]}
                    onChange={handleChange}
                    required={required}
                  >
                    <option value="">Select Organization</option>
                    {integration.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item?.organization?.name || item?.id}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type={type}
                    className="form-control"
                    name={name}
                    value={formData[name]}
                    onChange={handleChange}
                    required={required}
                    placeholder={!required ? '(Optional)' : ''}
                  />
                )}
              </div>
            ))}
          </div>

          <div className="d-flex justify-content-end mt-4">
            <button type="submit" className="btn btn-primary-500" disabled={isLoading}>
              {isLoading ? 'Adding...' : 'Add Phone Number'}
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
}

export default AddPhoneNumberModal;
